module.exports = __webpack_public_path__ + "img/fin-agent-answer-avatar-light.5ef1717.svg";